export const selectConfig = state => state.app.config;
export const selectAgent = state => state.app.agent;
